import React from "react";
import AccountingAutomaticOperations from "../../components/Accounting/AutomaticOperations";

export default function AccountingParamsScreen() {
    return (
        <AccountingAutomaticOperations />
    );
}